module.exports = __webpack_public_path__ + "static/media/CNews3.959c27ec.png";